export enum PaginateEvent {
    Next,
    Previous,
    Last,
    First
}

export class TablePaginate {

    current: number;
    currentItemCount: number;
    first: number;
    firstItemNumber: number;
    firstPageInRange: number;
    itemCountPerPage: number;
    last: number;
    lastItemNumber: number;
    lastPageInRange: number;
    next: number;
    pageCount: number;
    totalItemCount: number;

    pageSizeOptions: number[];


    constructor(data?: any, all?: boolean) {
        if (!data) {
            data = [];
        }

        this.current            = data['current'] ? data['current'] : 1;
        this.currentItemCount   = data['currentItemCount'] ? data['currentItemCount'] : null;
        this.first              = data['first'] ? data['first'] : null;
        this.firstItemNumber    = data['firstItemNumber'] ? data['firstItemNumber'] : null;
        this.firstPageInRange   = data['firstPageInRange'] ? data['firstPageInRange'] : null;
        this.itemCountPerPage   = data['itemCountPerPage'] ? data['itemCountPerPage'] : (all === true ? 1000 : 10);
        this.last               = data['last'] ? data['last'] : null;
        this.lastItemNumber     = data['lastItemNumber'] ? data['lastItemNumber'] : null;
        this.lastPageInRange    = data['lastPageInRange'] ? data['lastPageInRange'] : null;
        this.next               = data['next'] ? data['next'] : null;
        this.pageCount          = data['pageCount'] ? data['pageCount'] : null;
        this.totalItemCount     = data['totalItemCount'] ? data['totalItemCount'] : null;

        this.pageSizeOptions    = [5, 10, 20, 50, 100, 200];
    }

}
